/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Quote } from "./Quote";
import {
  QuoteFromJSON,
  QuoteFromJSONTyped,
  QuoteToJSON,
  QuoteToJSONTyped,
} from "./Quote";
import type { SelectQuotePlanAllowedToSwitch } from "./SelectQuotePlanAllowedToSwitch";
import {
  SelectQuotePlanAllowedToSwitchFromJSON,
  SelectQuotePlanAllowedToSwitchFromJSONTyped,
  SelectQuotePlanAllowedToSwitchToJSON,
  SelectQuotePlanAllowedToSwitchToJSONTyped,
} from "./SelectQuotePlanAllowedToSwitch";
import type { PaymentsServiceSwitchQuotePaymentPlan } from "./PaymentsServiceSwitchQuotePaymentPlan";
import {
  PaymentsServiceSwitchQuotePaymentPlanFromJSON,
  PaymentsServiceSwitchQuotePaymentPlanFromJSONTyped,
  PaymentsServiceSwitchQuotePaymentPlanToJSON,
  PaymentsServiceSwitchQuotePaymentPlanToJSONTyped,
} from "./PaymentsServiceSwitchQuotePaymentPlan";

/**
 *
 * @export
 * @interface SelectQuotePlan
 */
export interface SelectQuotePlan {
  /**
   *
   * @type {Quote}
   * @memberof SelectQuotePlan
   */
  originalQuote: Quote;
  /**
   *
   * @type {Quote}
   * @memberof SelectQuotePlan
   */
  newQuote: Quote;
  /**
   *
   * @type {SelectQuotePlanAllowedToSwitch}
   * @memberof SelectQuotePlan
   */
  allowedToSwitch: SelectQuotePlanAllowedToSwitch;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuotePlan
   */
  sameCarrier: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuotePlan
   */
  willMarkShipmentOnHold: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuotePlan
   */
  willSendCancelPickupEmail: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuotePlan
   */
  willMovePickupDateToToday: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuotePlan
   */
  willSelectNewQuote: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuotePlan
   */
  willClearProNumber: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuotePlan
   */
  willBookNewPickup: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuotePlan
   */
  willRegenerateDocuments: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuotePlan
   */
  willHandleCustomsDocuments: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuotePlan
   */
  willUpdateXeroProvisionalCarrierInvoice: boolean;
  /**
   *
   * @type {string}
   * @memberof SelectQuotePlan
   */
  visibilityReason?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuotePlan
   */
  confirmedWithCarrier: boolean;
  /**
   *
   * @type {PaymentsServiceSwitchQuotePaymentPlan}
   * @memberof SelectQuotePlan
   */
  paymentsPlan: PaymentsServiceSwitchQuotePaymentPlan;
}

/**
 * Check if a given object implements the SelectQuotePlan interface.
 */
export function instanceOfSelectQuotePlan(
  value: object,
): value is SelectQuotePlan {
  if (!("originalQuote" in value) || value["originalQuote"] === undefined)
    return false;
  if (!("newQuote" in value) || value["newQuote"] === undefined) return false;
  if (!("allowedToSwitch" in value) || value["allowedToSwitch"] === undefined)
    return false;
  if (!("sameCarrier" in value) || value["sameCarrier"] === undefined)
    return false;
  if (
    !("willMarkShipmentOnHold" in value) ||
    value["willMarkShipmentOnHold"] === undefined
  )
    return false;
  if (
    !("willSendCancelPickupEmail" in value) ||
    value["willSendCancelPickupEmail"] === undefined
  )
    return false;
  if (
    !("willMovePickupDateToToday" in value) ||
    value["willMovePickupDateToToday"] === undefined
  )
    return false;
  if (
    !("willSelectNewQuote" in value) ||
    value["willSelectNewQuote"] === undefined
  )
    return false;
  if (
    !("willClearProNumber" in value) ||
    value["willClearProNumber"] === undefined
  )
    return false;
  if (
    !("willBookNewPickup" in value) ||
    value["willBookNewPickup"] === undefined
  )
    return false;
  if (
    !("willRegenerateDocuments" in value) ||
    value["willRegenerateDocuments"] === undefined
  )
    return false;
  if (
    !("willHandleCustomsDocuments" in value) ||
    value["willHandleCustomsDocuments"] === undefined
  )
    return false;
  if (
    !("willUpdateXeroProvisionalCarrierInvoice" in value) ||
    value["willUpdateXeroProvisionalCarrierInvoice"] === undefined
  )
    return false;
  if (
    !("confirmedWithCarrier" in value) ||
    value["confirmedWithCarrier"] === undefined
  )
    return false;
  if (!("paymentsPlan" in value) || value["paymentsPlan"] === undefined)
    return false;
  return true;
}

export function SelectQuotePlanFromJSON(json: any): SelectQuotePlan {
  return SelectQuotePlanFromJSONTyped(json, false);
}

export function SelectQuotePlanFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SelectQuotePlan {
  if (json == null) {
    return json;
  }
  return {
    originalQuote: QuoteFromJSON(json["originalQuote"]),
    newQuote: QuoteFromJSON(json["newQuote"]),
    allowedToSwitch: SelectQuotePlanAllowedToSwitchFromJSON(
      json["allowedToSwitch"],
    ),
    sameCarrier: json["sameCarrier"],
    willMarkShipmentOnHold: json["willMarkShipmentOnHold"],
    willSendCancelPickupEmail: json["willSendCancelPickupEmail"],
    willMovePickupDateToToday: json["willMovePickupDateToToday"],
    willSelectNewQuote: json["willSelectNewQuote"],
    willClearProNumber: json["willClearProNumber"],
    willBookNewPickup: json["willBookNewPickup"],
    willRegenerateDocuments: json["willRegenerateDocuments"],
    willHandleCustomsDocuments: json["willHandleCustomsDocuments"],
    willUpdateXeroProvisionalCarrierInvoice:
      json["willUpdateXeroProvisionalCarrierInvoice"],
    visibilityReason:
      json["visibilityReason"] == null ? undefined : json["visibilityReason"],
    confirmedWithCarrier: json["confirmedWithCarrier"],
    paymentsPlan: PaymentsServiceSwitchQuotePaymentPlanFromJSON(
      json["paymentsPlan"],
    ),
  };
}

export function SelectQuotePlanToJSON(json: any): SelectQuotePlan {
  return SelectQuotePlanToJSONTyped(json, false);
}

export function SelectQuotePlanToJSONTyped(
  value?: SelectQuotePlan | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    originalQuote: QuoteToJSON(value["originalQuote"]),
    newQuote: QuoteToJSON(value["newQuote"]),
    allowedToSwitch: SelectQuotePlanAllowedToSwitchToJSON(
      value["allowedToSwitch"],
    ),
    sameCarrier: value["sameCarrier"],
    willMarkShipmentOnHold: value["willMarkShipmentOnHold"],
    willSendCancelPickupEmail: value["willSendCancelPickupEmail"],
    willMovePickupDateToToday: value["willMovePickupDateToToday"],
    willSelectNewQuote: value["willSelectNewQuote"],
    willClearProNumber: value["willClearProNumber"],
    willBookNewPickup: value["willBookNewPickup"],
    willRegenerateDocuments: value["willRegenerateDocuments"],
    willHandleCustomsDocuments: value["willHandleCustomsDocuments"],
    willUpdateXeroProvisionalCarrierInvoice:
      value["willUpdateXeroProvisionalCarrierInvoice"],
    visibilityReason: value["visibilityReason"],
    confirmedWithCarrier: value["confirmedWithCarrier"],
    paymentsPlan: PaymentsServiceSwitchQuotePaymentPlanToJSON(
      value["paymentsPlan"],
    ),
  };
}
